export default __webpack_public_path__ + "static/media/logo-color.f2f9d50f.svg";